const TYPES = require('reducers/availableRrcCoupons').ACTION_TYPES;

const updateRrcCoupons = data => ({
    type: TYPES.UPDATE_RRC_COUPONS,
    data: data
});

module.exports = {
    TYPES,
    updateRrcCoupons
};
